<template>
  <q-dialog v-model="visible" full-height position="right">
    <q-card class="full-card" :style="userInfo.canWriteApp ? 'width: 80vw !important' : 'width: 60vw !important'">
      <q-card-section>
        <div class="max-height-dialog row">
          <div class="column col">
            <PreviewPanel
              v-model="form.contents"
              :hoverPath="hoverPath"
              :isAdmin="userInfo.canWriteApp"
              :isSuper="userInfo.isSuper"
              :errorPath="errorPath"
              :isChanged="isChanged"
              :altText="form.altText"
              @update:hoverPath="(args) => (hoverPath = args)"
              @initMessage="onInitMessage"
              @onSelectNode="onSelectNodeFromPreview"
              @update:altText="updateAltText"
            />
          </div>
          <div class="column col" v-if="userInfo.canWriteApp">
            <TreePanel
              ref="treePanel"
              v-model="form.contents"
              :errorPath="errorPath"
              :isAdmin="userInfo.canWriteApp"
              @onSelectNode="onSelectNode"
              @onHoverNode="onHoverNode"
            />
          </div>
          <div class="col column justify-between">
            <div>
              <q-toolbar class="auto-height horizontal-line">
                <q-toolbar-title class="q-pa-sm"> Poti-Potiフレックス </q-toolbar-title>
                <q-btn flat round dense icon="close" @click="onCancel" />
              </q-toolbar>
            </div>
            <FormPanel
              v-model="form.contents"
              :altText="form.altText"
              :selectedPath="selectedPath"
              :nodePath="nodePath"
              :isAdmin="userInfo.canWriteApp"
              @update:altText="(val) => (form.altText = val)"
              @update:validateValue="onValidate"
              ref="formPanel"
            />
            <div class="row no-wrap items-center q-my-md q-pr-md">
              <q-space />
              <div class="q-gutter-sm">
                <q-btn no-caps flat class="btn-cancel" @click="onCancel">{{ $t('cancel') }} </q-btn>
                <q-btn no-caps class="btn-save" @click="onSubmit"> {{ $t('save') }} </q-btn>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexAnswer, IFlexMessageBubble, IFlexMessageCarousel } from '@/utils/types'
import PreviewPanel from '@/components/common/flex-message/PreviewPanel.vue'
import TreePanel from '@/components/common/flex-message/TreePanel.vue'
import FormPanel from '@/components/common/flex-message/FormPanel.vue'
import cloneDeep from 'lodash/cloneDeep'
import { UserModel } from '@/models/user-model'

@Options({
  components: { FormPanel, TreePanel, PreviewPanel },
  directives: { maska },
  emits: ['update:data'],
})
export default class FlexMessageModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  flexAnwser!: IFlexAnswer

  hoverPath = ''
  selectedPath = ''
  nodePath = []
  errorPath: string[] = []

  form: IFlexAnswer = {}

  get userInfo(): UserModel {
    return this.$store.getters.userInfo
  }

  onInitMessage(message: IFlexMessageBubble | IFlexMessageCarousel) {
    this.errorPath = []
    if (this.userInfo.canWriteApp) {
      this.$nextTick(() => {
        this.$refs.treePanel.initMessage(message)
      })
    }
  }

  onSelectNode(path, nodePath) {
    this.selectedPath = path
    this.nodePath = nodePath
  }

  onSelectNodeFromPreview(path, node, nodePath) {
    if (this.errorPath.length === 0) {
      this.onSelectNode(path, nodePath)
      if (this.userInfo.canWriteApp) {
        this.$nextTick(() => {
          this.$refs.treePanel.onSelectNode(node, path)
        })
      }
    }
  }

  onHoverNode(path) {
    this.hoverPath = path
  }

  onValidate(val) {
    const index = this.errorPath.indexOf(this.selectedPath)

    if (!val) {
      if (index === -1) {
        this.errorPath.push(this.selectedPath)
      }
    } else {
      if (index !== -1) {
        this.errorPath.splice(index, 1)
      }
    }
  }

  async onSubmit() {
    if (this.errorPath.length === 0 && this.form.altText !== '') {
      this.$emit('update:data', this.form)
      this.visible = false
    }
    if (this.form.altText === '') {
      this.$q.notify({
        type: 'negative',
        message: this.$t('validate.this_field_is_required', {
          placeholder: this.$t('label.common.answer.alt_text'),
        }),
      })
    }
  }

  updateAltText(val) {
    if (!this.form.altText) {
      this.form.altText = val
    }
  }

  mounted() {
    this.form = { ...this.form, ...cloneDeep(this.flexAnwser) }
    // eslint-disable-next-line
    this.parentForm = this.form as any
    this.initForm = cloneDeep(this.parentForm)
  }
}
</script>

<style scoped lang="scss">
.max-height-dialog {
  height: 100vh;
  overflow-x: auto;
}
</style>
